import { render } from "./ImportProducts.vue?vue&type=template&id=7a0d5211&scoped=true"
import script from "./ImportProducts.vue?vue&type=script&lang=js"
export * from "./ImportProducts.vue?vue&type=script&lang=js"

import "./ImportProducts.vue?vue&type=style&index=0&id=7a0d5211&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0d5211"]])

export default __exports__